import { useState, useRef, useEffect } from "react"
import useToggle from "../../utility/hooks/useToggle"
import FooterHomeThree from "./FooterHomeThree"
import HeaderHomeThree from "./HeaderHomeThree"
import LinesEllipsis from "react-lines-ellipsis"
import TablePagination from "../shared/TablePagination"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody,
  Col,
  CardImg,
  CardText,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Spinner
} from "reactstrap"
import axiosRequest from "../../configs/axios"
import whitelabelConfig from "@configs/whitelabel"
import noImage from "../../assets/images/no-poster-back.png"
import noImageSquare from "../../assets/images/no-image-back.png"
import { Link, useHistory } from "react-router-dom"

import { useDispatch, useSelector } from "react-redux"
import { send, clear } from "@store/websocket"
import SearchItems from "../shared/SearchItems"
import SpinnerComponent from "../../@core/components/spinner/Fallback-spinner"

function ExplorePage() {
  const [drawer, drawerAction] = useToggle(false)
  const [active, setActive] = useState("2")
  const [items, setItems] = useState([])
  const [searchValue, setSearchValue] = useState()
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992)
  const [showDownloadModal, setShowDownloadModal] = useState(false)
  const [downloadUrl, setDownloadUrl] = useState("")
  const [spinner, setSpinner] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const itemsPerPage = useRef(30)

  let url = "/"

  const toggle = (tab) => {
    if (active !== tab) {
      setActive(tab)
    }
  }

  const getItems = async (url) => {
    try {
      setSpinner(true)
      const { data } = await axiosRequest.get(url)
      setItems(data)
      setTotalItems(data.totalResults)
    } catch (err) {
      console.error("Error fetching results:", err)
    } finally {
      setSpinner(false)
    }
  }

  const getDownloadUrl = async () => {
    await axiosRequest
      .post("/checkForUpdates", {
        downloadUrl: `#`,
        whitelabel: whitelabelConfig.WHITELABEL_ID
      })
      .then((response) => {
        if (response?.data?.downloadUrl) {
          //console.log(response.data.downloadUrl)
          setDownloadUrl(response.data.downloadUrl)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleShowDownloadModal = () => {
    setShowDownloadModal(!showDownloadModal)
  }

  const getBaseUrl = () => {
    switch (active) {
      case "1": return `/getCollections?whitelabel=${whitelabelConfig.WHITELABEL_ID}`
      case "2": return `/getMovies?startIndex=0&sortBy=releaseDate&sortAscending=false&whitelabel=${whitelabelConfig.WHITELABEL_ID}`
      case "3": return `/getShows?startIndex=0&sortBy=lastAirDate&sortAscending=false&whitelabel=${whitelabelConfig.WHITELABEL_ID}`
      default: return ""
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchValue && active === "1") {
        url = `/getCollections?searchText=${encodeURIComponent(searchValue)}&whitelabel=${whitelabelConfig.WHITELABEL_ID}`
      } else if (searchValue && active === "2") {
        url = `/getMovies?startIndex=0&sortBy=releaseDate&sortAscending=false&query=${encodeURIComponent(searchValue)}&whitelabel=${whitelabelConfig.WHITELABEL_ID}`
      } else if (searchValue && active === "3") {
        url = `/getShows?startIndex=0&sortBy=lastAirDate&sortAscending=false&query=${encodeURIComponent(searchValue)}&whitelabel=${whitelabelConfig.WHITELABEL_ID}`
      } else {
        // cleared the search → reload the “all items” for the active tab
        url = getBaseUrl()
      }
  
      getItems(url)
      setSpinner(false)
    }, 500)

    return () => clearTimeout(handler) // clean up previous timeout
  }, [searchValue, active])

  const handleChange = (e) => {
    setSpinner(true)
    setSearchValue(e.target.value)
  }

  useEffect(() => {
    url = getBaseUrl()
    getItems(url)

    setSearchValue("")

    getDownloadUrl()

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 992)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [active])

  const handlePageChange = (page) => {
    const start = (page - 1) * itemsPerPage.current
    let url
    if (active === "2") {
      url = `/getMovies?startIndex=${start}&sortBy=releaseDate&sortAscending=false`
      if (searchValue) url += `&query=${encodeURIComponent(searchValue)}`
    } else if (active === "3") {
      url = `/getShows?startIndex=${start}&sortBy=lastAirDate&sortAscending=false`
      if (searchValue) url += `&query=${encodeURIComponent(searchValue)}`
    }
    getItems(url)
  }

  return (
    <>
      <HeaderHomeThree action={drawerAction.toggle} />
      <section
        className={isSmallScreen ? "appie-hero-area appie-hero-3-area for-small-screen min-vh-100" : "appie-hero-area appie-hero-3-area min-vh-100"}
        style={{ background: "transparent" }}
      >
        <div 
          className="container" 
          style={{ paddingLeft: "2.1rem", paddingRight: "2.1rem" }}
        >
          <Card className="card-horizontal-menu">
            <div className="container" style={{ paddingLeft: "1.6rem", paddingRight: "1.6rem" }}>
              <CardBody className="px-0">
                <Nav tabs>
                  {/* <NavItem>
                    <NavLink
                      active={active === "1"}
                      onClick={() => {
                        toggle("1")
                      }}
                    >
                      TV
                    </NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink
                      active={active === "2"}
                      onClick={() => {
                        toggle("2")
                      }}
                    >
                      Movies
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={active === "3"}
                      onClick={() => {
                        toggle("3")
                      }}
                    >
                      TV Shows
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardBody>
            </div>
          </Card>
        </div>
        <div 
          className="container" 
          style={{ paddingLeft: "2.1rem", paddingRight: "2.1rem" }}
        >
          <TabContent activeTab={active}>
            {/* <TabPane tabId="1">
              <div className="searchItemsContainer custom">
                <Input
                  type="text"
                  className="me-1"
                  id="searchByNameOrTitle"
                  placeholder="Search ..."
                  onChange={handleChange}
                  value={searchValue || ""}
                />
                {spinner ? <Spinner size="sm" style={{ marginTop: "-1.2rem", marginRight: "-1rem" }} /> : ""}
              </div>
              <div className="results row">
                {Object.values(items?.collections || [])?.length !== 0
                  ? Object.values(items.collections)?.map((result) => (
                      <Col
                        xxl="2"
                        xl="3"
                        lg="3"
                        md="4"
                        sm="6"
                        xs="6"
                        className="d-flex justify-content-center align-items-center"
                        key={result.id}
                      >
                        <Link to={`explore/tv-channels/${result.id}`}>
                          <Card
                            // onClick={() => handleMovieClick(i)}
                            className="mb-1 custom-card-square"
                          >
                            {result.logoUrl ? (
                              <CardImg
                                className="custom-card-square-image"
                                top
                                src={result.logoUrl}
                                onError={(e) => {
                                  e.currentTarget.src = noImageSquare
                                }}
                                alt="card-top"
                              />
                            ) : (
                              <CardImg
                                className="custom-card-square-image"
                                top
                                src={noImageSquare}
                                alt="card-top"
                              />
                            )}
                            <CardBody>
                              <h6 className="mb-0">
                                <LinesEllipsis
                                  text={result.name}
                                  maxLine="5"
                                  ellipsis={<>...</>}
                                  basedOn="letters"
                                />
                              </h6>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                    ))
                  : null}
              </div>
            </TabPane> */}
            <TabPane tabId="2">
              <div className="searchItemsContainer custom">
                <Input
                  type="text"
                  className="me-1"
                  id="searchByNameOrTitle"
                  placeholder="Search ..."
                  onChange={handleChange}
                  value={searchValue || ""}
                />
                {spinner ? <Spinner size="sm" style={{ marginTop: "-1.2rem", marginRight: "-1rem" }} /> : ""}
              </div>
              <div className="results row">
                {Object.values(items?.movies || [])?.length !== 0
                  ? Object.values(items.movies)?.map((result) => (
                      <Col
                        xxl="2"
                        xl="3"
                        lg="3"
                        md="4"
                        sm="6"
                        xs="6"
                        className="d-flex justify-content-center align-items-center"
                        key={result.id}
                      >
                        <Card
                          onClick={handleShowDownloadModal}
                          className="mb-1 custom-card-poster"
                        >
                          {result.posterUrl ? (
                            <CardImg
                              className="custom-card-poster-image"
                              top
                              src={result.posterUrl}
                              onError={(e) => {
                                e.currentTarget.src = noImage
                              }}
                              alt="card-top"
                            />
                          ) : (
                            <CardImg
                              className="custom-card-poster-image"
                              top
                              src={noImage}
                              alt="card-top"
                            />
                          )}

                          <CardBody>
                            <h6 className="mb-0">
                              <LinesEllipsis
                                text={result.title}
                                maxLine="5"
                                ellipsis={<>...</>}
                                basedOn="letters"
                              />
                            </h6>

                            <small className="text-muted d-block">
                              {new Date(result.releaseDate)
                                .toString()
                                .slice(3, 15)}
                            </small>
                          </CardBody>
                        </Card>
                      </Col>
                    ))
                  : null}
              </div>
              {!searchValue && items?.movies?.length > 0 && (
                <span style={{ borderRadius: "10px", marginBottom: "1rem", width: "100%", overflow: "hidden" }}>
                  <TablePagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage.current}
                    onPageChange={handlePageChange}
                  />
                </span>
              )}
            </TabPane>
            <TabPane tabId="3">
              <div className="searchItemsContainer custom">
                <Input
                  type="text"
                  className="me-1"
                  id="searchByNameOrTitle"
                  placeholder="Search ..."
                  onChange={handleChange}
                  value={searchValue || ""}
                />
                {spinner ? <Spinner size="sm" style={{ marginTop: "-1.2rem", marginRight: "-1rem" }} /> : ""}
              </div>
              <div className="results row">
                {Object.values(items?.shows || [])?.length !== 0
                  ? Object.values(items.shows)?.map((result) => (
                      <Col
                        xxl="2"
                        xl="3"
                        lg="3"
                        md="4"
                        sm="6"
                        xs="6"
                        className="d-flex justify-content-center align-items-center"
                        key={result.id}
                      >
                        <Card
                          onClick={handleShowDownloadModal}
                          className="mb-1 custom-card-poster"
                        >
                          {result.posterUrl ? (
                            <CardImg
                              className="custom-card-poster-image"
                              top
                              src={result.posterUrl}
                              onError={(e) => {
                                e.currentTarget.src = noImage
                              }}
                              alt="card-top"
                            />
                          ) : (
                            <CardImg
                              className="custom-card-poster-image"
                              top
                              src={noImage}
                              alt="card-top"
                            />
                          )}

                          <CardBody>
                            <h6 className="mb-0">
                              <LinesEllipsis
                                text={result.name}
                                maxLine="5"
                                ellipsis={<>...</>}
                                basedOn="letters"
                              />
                            </h6>

                            <small className="text-muted d-block">
                              {new Date(result.firstAirDate)
                                .toString()
                                .slice(3, 15)}
                            </small>
                          </CardBody>
                        </Card>
                      </Col>
                    ))
                  : null}
              </div>
              {!searchValue && items?.shows?.length > 0 && (
                <span style={{ borderRadius: "10px", marginBottom: "1rem", width: "100%", overflow: "hidden" }}>
                  <TablePagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage.current}
                    onPageChange={handlePageChange}
                  />
                </span>
              )}
            </TabPane>
          </TabContent>

          <Modal
            scrollable
            isOpen={showDownloadModal}
            toggle={handleShowDownloadModal}
            className="modal-dialog-centered"
          >
          <ModalHeader toggle={handleShowDownloadModal}>
            Download Aflix
          </ModalHeader>
          <ModalBody className="modal-body-with-simple-text">
            <CardText className="register-success-disclaimer mt-0 h1" style={{ color: "white" }}>
              Watch Movies, Shows and more!
            </CardText>
            <CardText className="register-success-disclaimer mt-2" style={{ color: "gray" }}>
              Our app supports all Android (phones, tablets, TVs, TV boxes) and FireTV OS devices.
            </CardText>
            <p className="auth-footer text-center">
              <a
                href={downloadUrl}
                className="main-btn mt-3"
                style={{
                  background: "#167ac7",
                  borderColor: "#54b5ff",
                  color: "white",
                  padding: "5px 30px",
                  fontSize: "18px",
                  display: "inline-block"
                }}
                disabled
              >
                Download for Android
              </a>
            </p>
          </ModalBody>
          </Modal>
        </div>
      </section>
      <FooterHomeThree />
    </>
  )
}

export default ExplorePage
